<template>
  <b-modal id="modal-catatan" title="History Keputusan" variant="primary" size="lg" ref="modalCatatan" hide-footer
    no-close-on-esc>
    <loading :active.sync="this.$store.state.barpin.isLoadingModal" :is-full-page="false"></loading>
    <table class="table table-bordered table-responsive">
      <thead>
        <tr>
          <th>Nama Petugas</th>
          <th>Status</th>
          <th>Keputusan</th>
          <th>Waktu Mulai</th>
          <th>Waktu Selesai</th>
          <th>Catatan</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="listCatatan in $store.state.barpin.catatan" :key="listCatatan.WK_MULAI">
          <td>{{ listCatatan.nama_petugas == null ? '' : listCatatan.nama_petugas.NAMA}}</td>
          <td>{{ listCatatan.status_name.ur_status}}</td>
          <td>{{ listCatatan.FL_KEPUTUSAN === 'Y' ? 'Setuju' : (listCatatan.FL_KEPUTUSAN === 'T' ? 'Ditolak' : listCatatan.FL_KEPUTUSAN === 'X' ? 'Ditolak' :
              listCatatan.FL_KEPUTUSAN)
          }}</td>
          <td>{{ listCatatan.WK_MULAI}}</td>
          <td>{{ listCatatan.WK_SELESAI}}</td>
          <td>{{ listCatatan.KETERANGAN}}</td>
        </tr>
      </tbody>
    </table>
  </b-modal>
</template>
<script>
// import { mapActions } from 'vuex'
// import swal from 'sweetalert'
export default {
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalCatatan.vue?1538ce47